import * as moment from "moment";

export function getMonthsInYear(startDate: number | moment.Moment | Date) {
    const curYear = moment(startDate).year();
    const month = [];

    for (let i = 0; i < 12; i++) {
        const startDate = new Date(curYear, i, 1);
        month.push({
            start: moment(startDate).startOf('month'),
            end: moment(startDate).endOf('month'),
        });
    }

    return month;
}